import { render, staticRenderFns } from "./BinderContainer.vue?vue&type=template&id=68483f19&"
import script from "./BinderContainer.vue?vue&type=script&lang=js&"
export * from "./BinderContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports